import { Box } from 'braid-design-system';

import CustomSvg from 'src/components/CustomSvg/CustomSvg';
import SellingABusinessSvg from 'src/images/SellingABusiness.svg';

import FindOutMore from '../FindOutMore/FindOutMore';
import SellingMessage from '../SellingMessage/SellingMessage';

import * as styles from './style.css';

const DesktopMessage = () => (
  <Box
    style={{
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: 20,
      height: '100%',
      minHeight: 330,
    }}
  >
    <Box
      height="full"
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
    >
      <SellingMessage>
        <FindOutMore />
      </SellingMessage>
    </Box>

    <Box display="flex" justifyContent="center">
      <Box className={styles.svgContainer}>
        <CustomSvg svg={SellingABusinessSvg} width={330} />
      </Box>
    </Box>
  </Box>
);

export default DesktopMessage;
